import { FooterSection, FooterContact, FooterLink } from './NavigationTypes';


export const FOOTER_CONTACT: FooterContact = {
  phone: '+1 (802) 922-6268',
  email: 'info@clientvitals.com'
};


export const FOOTER_NAVIGATION_LINKS: FooterLink[] = [
  { name: 'Home', link: '/' },
  { name: 'Enterprise Products', link: '/enterprise-tiers' },
  { name: 'NEATT', link: '/neatt' },
  { name: 'About', link: '/about' },
  { name: 'Trusted Partners', link: '/trusted-partners' },
  { name: 'Contact', link: '#contact' }
];


export const FOOTER_ACCOUNT_LINKS: FooterLink[] = [
  { name: 'Login', link: '/auth/login' },
  { name: 'Enterprise SignUp', link: '/enterprise-tiers' }, 
  { name: 'Schedule Demo', link: 'https://calendly.com/jonathan-goffe-vermontconsumercredit/1-2-1-meeting-bni-professional-inquires', external: true }
];


export const FOOTER_LEGAL_LINKS: FooterLink[] = [
  { 
    name: 'Terms of Use', 
    link: 'https://www.dropbox.com/scl/fi/ueb58s7eli31z6jfry3ke/ToS.pdf?rlkey=nq3erxn19cj0x808l7fapfb7t&st=aaexcp2s&dl=0', 
    external: true 
  },
  { 
    name: 'Privacy Policy', 
    link: 'https://www.dropbox.com/scl/fi/16gh8d8js25cyjajh04vn/Privacy-Policy.pdf?rlkey=wm8ah4j9t7f1t5fnmuffi7df0&st=nz4jr1hq&dl=0', 
    external: true 
  }
];


export const COPYRIGHT_YEAR = 2025;
export const COMPANY_NAME = 'ClientVitals';


